import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-square-button',
  templateUrl: './square-button.component.html',
  styleUrls: ['./square-button.component.scss']
})
export class SquareButtonComponent {

  @Input() actionType: 'adding' | 'editing' | 'cancel' = 'adding';
  @Output() newActionStarted = new EventEmitter();
  @Input() disabled: boolean = false;
  @Input() hideBtnOnDisabled: boolean = false;

  newAction() {
    if (this.disabled) {
      return
    }
    this.newActionStarted.emit(this.actionType);
  }
}
